import type { BaseKeyFunction } from "../../../lib/types/baseKeyFunction";
import type { BibleBookId } from "../../../lib/types/schema/bible/bibleManifestSchema";

export const keyBibleCSS: BaseKeyFunction<{
  cookies: string;
  translationId: number;
}> = ({ translationId, cookies }) => ["bible-css", cookies, translationId];
export const keyBibleHTML: BaseKeyFunction<{
  cookies: string;
  translationId: number;
  bookAbbr: BibleBookId;
}> = ({ translationId, bookAbbr, cookies }) => [
  "bible-html",
  cookies,
  translationId,
  bookAbbr,
];
export const keyBibleJSON: BaseKeyFunction<{
  cookies: string;
  translationId: number;
}> = ({ translationId, cookies }) => ["bible-json", cookies, translationId];
